import React from 'react';
interface Column<T> {
  key: string;
  header: string;
  render: (item: T) => React.ReactNode;
  className?: string;
}
interface DataTableProps<T> {
  columns: Column<T>[];
  data: T[];
  keyExtractor: (item: T) => string;
  onRowClick?: (item: T) => void;
  emptyMessage?: string;
  className?: string;
}
export function DataTable<T>({
  columns,
  data,
  keyExtractor,
  onRowClick,
  emptyMessage = 'Không có dữ liệu',
  className = ''
}: DataTableProps<T>) {
  return <div className={`overflow-x-auto ${className}`} data-id="element-582">
      <table className="w-full" data-id="element-583">
        <thead data-id="element-584">
          <tr className="border-b border-[#2A2A2A]" data-id="element-585">
            {columns.map(col => <th key={col.key} className={`text-left text-xs font-semibold text-[#666666] uppercase tracking-wider px-4 py-3 ${col.className || ''}`} data-id="element-586">
                {col.header}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-587">
          {data.length === 0 ? <tr data-id="element-588">
              <td colSpan={columns.length} className="text-center py-12 text-[#666666]" data-id="element-589">
                {emptyMessage}
              </td>
            </tr> : data.map(item => <tr key={keyExtractor(item)} className={`border-b border-[#2A2A2A]/50 transition-colors duration-150 ${onRowClick ? 'cursor-pointer hover:bg-[#222222]' : ''}`} onClick={() => onRowClick?.(item)} data-id="element-590">
                {columns.map(col => <td key={col.key} className={`px-4 py-3 text-sm ${col.className || ''}`} data-id="element-591">
                    {col.render(item)}
                  </td>)}
              </tr>)}
        </tbody>
      </table>
    </div>;
}